module.exports = __webpack_public_path__ + "static/media/last_step.35751b37.svg";